import { Module } from '@nestjs/common';
import { ColumnsService } from './columns.service';
import { ColumnsController } from './columns.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ColumnsRepository } from './columns.repository';
import { ColumnsAdapter } from './dto/columns-adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([ColumnsRepository])
  ],

  providers: [ColumnsService,ColumnsAdapter, ApplicationExceptionHandler,LogsService],
  controllers: [ColumnsController]
})
export class ColumnsModule {}
